import React from "react";
import { Switch, Group, ActionIcon, Box } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import InfoCircle from "../dataDisplay/infoCircle";

interface SettingsToggleProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  infoLink: string;
}

const SettingsToggle: React.FC<SettingsToggleProps> = ({
  label,
  checked,
  onChange,
  infoLink,
}) => (
  <Group justify="flex-start" gap="xs" wrap="nowrap">
    <Box style={{ display: "flex", alignItems: "center", maxWidth: "100%" }}>
      <Switch
        label={label}
        style={{ marginRight: "0.3rem" }}
        checked={checked}
        onChange={(event) => onChange(event.currentTarget.checked)}
      />
      {/* <InfoCircle infoLink={infoLink} /> */}
    </Box>
  </Group>
);

export default SettingsToggle;
